import React, { Component } from 'react';

import {Container, Row, Col} from './BootstrapGrid';
import {Headline, Subheading} from './Typography';
import SignupButton from './SignupButton';

import muiThemeable from 'material-ui/styles/muiThemeable';


class HowItWorksSection_ extends Component {
  constructor(props) {
    super(props);

    this.style = {
      backgroundColor: this.props.muiTheme.palette.canvasColor,
      color: this.props.muiTheme.palette.textColor,
      paddingTop: "2em",
      paddingBottom: "2em",
      textAlign: "center",
      fontFamily: this.props.muiTheme.fontFamily,
    }
  }

  render() {
    return (
      <div style={this.style} className="how-it-works">
        <Container style={{maxWidth: "90%", width: "600px"}}>
          <Row>
            <Col cols={12}>
              <Headline>{this.props.text}</Headline>
            </Col>
            {this.props.children}
          </Row>
        </Container>
        <SignupButton
          artists={this.props.artists}
          primary={true}
          style={{marginTop: "3em"}}>
          Get Started
        </SignupButton>
      </div>
    )
  }
}
const HowItWorksSection = muiThemeable()(HowItWorksSection_)

class HowItWorksItem_ extends Component {
  render() {
    return (
      <Col cols={4} align="top">
        <div>
          <div style={{padding: "2em 2em 2em 2em"}}>
            {this.props.icon}
          </div>
          <Subheading>{this.props.text}</Subheading>
        </div>
      </Col>
    )
  }
}

const HowItWorksItem = muiThemeable()(HowItWorksItem_)

export { HowItWorksSection, HowItWorksItem };



// WEBPACK FOOTER //
// ./src/HowItWorks.js